<template>
    <form id="add_task_form" :action="save_route" method="post" class="mt-5">
        <input type="hidden" name="_token" v-bind:value="csrf">
        <table class="table simple-table table-striped table-sm mt-4">
            <thead>
            <tr>
                <th scope="col">{{ $lang('Nazwisko') }}</th>
                <th scope="col">{{ $lang('Imię') }}</th>
                <th scope="col">{{ $lang('E-mail') }}</th>
                <th scope="col">{{ $lang('Akcje') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="people.length<=0" class="table-light">
                <th>
                    {{ $lang('Brak osób z SBS') }}
                </th>
            </tr>
            <tr v-else v-for="person in people">
                <td :data-title="$lang('Nazwisko')">{{ person.surname }}</td>
                <td :data-title="$lang('Imię')">{{ person.name }}</td>
                <td :data-title="$lang('E-mail')">{{ person.email }}</td>
                <td :data-title="$lang('Akcje')">
                    <span v-on:click="showDetails(person.id)">
                        <span class="d-md-none" :id="'details-span-'+person.id">{{ $lang('Rozwiń') }}</span>
                        <i :id="'details-btn-'+person.id"
                           class="fa-angle-double-down fa tile icon fa-lg float-right mr-2 mt-1"
                           aria-hidden="true">
                        </i>
                    </span>
                    <div :hidden="true" :id="'details-'+person.id" hidden="true">
                        <div v-for="(value, index) in types" v-if="project_types.includes(value)">
                            <input type="checkbox" :id="value + person.id"
                                   :name="value +'[]'"
                                   :value="person.id"
                                   :checked="person.types.includes(value)"
                            >
                            <label :for="value + person.id">
                                {{ labels[index] }}
                            </label>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <hr>
        <button class="pull-right btn btn-primary  mt-3 mb-3" type="submit">
            {{ $lang('Zapisz ustawienia') }}
        </button>
    </form>
</template>

<script>

export default {
    name: 'mail-settings-form',
    props: {
        csrf: String,
        save_route: String,
        people: Array,
        types: Object,
        project_types: Array,
    },
    data() {
        return {
            labels: {
                'CRASH': this.$lang('Zgłoszenie uwagi o kryterium Awaria / Defekt krytyczny'),
                'TECHNICAL_ISSUE': this.$lang('Zgłoszenie uwagi o kryterium Problem techniczny'),
                'HIGH_DEFECT': this.$lang('Zgłoszenie uwagi o kryterium Defekt wysoki'),
                'LOW_DEFECT': this.$lang('Zgłoszenie uwagi o kryterium Defekt niski'),
                'INQUIRY': this.$lang('Zgłoszenie uwagi o kryterium Zapytanie'),
                'PROGRAM_ERROR': this.$lang('Zgłoszenie uwagi o kryterium Błąd programu'),
                'ANALYSED_REMINDER': this.$lang('Przypomnienie o zgłoszeniu ze statusem Analizowane'),
                'COMMENT_REMINDER': this.$lang('Przypomnienie o zgłoszeniu ze statusem Komentarz'),
                'MORE_INFO_REMINDER': this.$lang('Przypomnienie o zgłoszeniu ze statusem Więcej informacji'),
                'MAILING_TEST': this.$lang('Próbny mailing'),
                'SURVEYS': this.$lang('Informacja o przesłanych ankietach'),
                'SHIFT_SUMMARY': this.$lang('Raport z podsumowania dyżuru'),
                'FORCE_PASSWORD_CHANGE_CONFIRM': this.$lang('Potwierdzenie wymuszenia zmiany hasła'),
                'REMOTE_JOB_NO_CONSULTATIONS': this.$lang('Mailing dla prac zdalnych bez zamówionych konsultacji'),
                'TASKS_DAILY_REPORT': this.$lang('Codzienny raport dotyczący zgłoszeń niezrealizowanych')
            }
        }
    },
    methods: {
        showDetails(id) {
            let div = document.getElementById('details-' + id);
            let btn = document.getElementById('details-btn-' + id);
            let span = document.getElementById('details-span-' + id);
            if (div.hidden === false) {
                div.hidden = true;
                btn.classList.remove('fa-angle-double-up')
                btn.classList.add('fa-angle-double-down')
                span.innerText = this.$lang('Rozwiń');
            } else {
                div.hidden = false;
                btn.classList.remove('fa-angle-double-down')
                btn.classList.add('fa-angle-double-up')
                span.innerText = this.$lang('Zwiń');
            }
        }
    }
}
</script>


